export const environment = {
  production: true,
  apiUrl: 'http://localhost:8000',
  //apiUrl: 'https://edone.store/backend',
  recaptcha: {
    siteKey: '6LdKYC0gAAAAAB2XLK434Qk9xc361udSXxrFxPTJ',
  },
};
